import React from "react";
import axios from "axios";
import { Row, Container, Col } from "react-bootstrap";
import { withRouter } from "react-router";
import { Bar } from "react-chartjs-2";
import { t } from "../../../localization/localization";

import scholarLogo from "../../../assets/google_scholar_logo.png";
import { stringToArray } from "../../../utils/arrayFormatter";

class DashboardExternalScholar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: null,
    };
  }

  componentDidMount() {
    this.getExternalScholar();
  }

  getExternalScholar = () => {
    axios
      .get(
        `${window._env_.BASE_URL}/gcris-api/researcher/${this.props.crisId}/external-metrics/scholar`
      )
      .then((res) => {
        this.setState({ data: res.data });
      });
  };

  render() {
    const urlSearchParams = new URLSearchParams(this.props.location.search);
    const locale = urlSearchParams.get("locale") ?? "tr";

    if (
      !this.state.data ||
      !this.state.data.name ||
      !this.state.data.citesperyear
    ) {
      return null;
    }

    const citesperyear = this.state.data.citesperyear
      .slice(1, -1)
      .split(", ")
      .map((e) => e.split(": "))
      .reduce((acc, cur) => {
        acc[cur[0]] = cur[1];
        return acc;
      }, {});
    return (
      <Container fluid>
        <Row className="wall">
          <Col>
            <a
              target="_blank"
              href={this.props.googleScholar}
              style={{ textDecoration: "none" }}
            >
              <img src={scholarLogo} style={{ height: 36, marginBottom: 16 }} />
              <Row className="text-center">
                <Col lg="12">
                  <Row className="text-center" style={{ marginBottom: 0 }}>
                    <Col xs={12} md={6} lg={2}>
                      <div>
                        <h4 style={{ color: "#275DAD" }}>
                          {t(
                            locale,
                            "/rs/profile/dashboardExternalScholar/articles"
                          )}
                        </h4>
                        <h1 style={{ color: "#001F54" }}>
                          {this.state.data.documentcount}
                        </h1>
                      </div>
                    </Col>
                    <Col xs={12} md={6} lg={2}>
                      <div>
                        <h4 style={{ color: "#275DAD" }}>
                          {t(
                            locale,
                            "/rs/profile/dashboardExternalScholar/citations"
                          )}
                        </h4>
                        <h1 style={{ color: "#001F54" }}>
                          {this.state.data.citedby +
                            " / " +
                            this.state.data.citedby5y}
                        </h1>
                        <h6 style={{ color: "#275DAD" }}>
                          {t(
                            locale,
                            "/rs/profile/dashboardExternalScholar/allSince2016"
                          )}
                        </h6>
                      </div>
                    </Col>
                    <Col xs={12} md={6} lg={2}>
                      <div>
                        <h4 style={{ color: "#275DAD" }}>
                          {t(
                            locale,
                            "/rs/profile/dashboardExternalScholar/hIndex"
                          )}
                        </h4>
                        <h1 style={{ color: "#001F54" }}>
                          {this.state.data.hindex +
                            " / " +
                            this.state.data.hindex5y}
                        </h1>
                        <h6 style={{ color: "#275DAD" }}>
                          {t(
                            locale,
                            "/rs/profile/dashboardExternalScholar/allSince2016"
                          )}
                        </h6>
                      </div>
                    </Col>
                    <Col xs={12} md={6} lg={3}>
                      <div>
                        <h4 style={{ color: "#275DAD" }}>
                          {t(
                            locale,
                            "/rs/profile/dashboardExternalScholar/i10Index"
                          )}
                        </h4>
                        <h1 style={{ color: "#001F54" }}>
                          {this.state.data.i10index +
                            " / " +
                            this.state.data.i10index5y}
                        </h1>
                        <h6 style={{ color: "#275DAD" }}>
                          {t(
                            locale,
                            "/rs/profile/dashboardExternalScholar/allSince2016"
                          )}
                        </h6>
                      </div>
                    </Col>
                    <Col xs={12} md={6} lg={3}>
                      <div>
                        <h4 style={{ color: "#275DAD" }}>
                          {t(
                            locale,
                            "/rs/profile/dashboardExternalScholar/coAuthors"
                          )}
                        </h4>
                        <h1 style={{ color: "#001F54" }}>
                          {this.state.data.coauthorcount}
                        </h1>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row>
                <Col sm="12" md="8" style={{ color: "#001F54" }}>
                  <h4>
                    {t(
                      locale,
                      "/rs/profile/dashboardExternalScholar/citesPerYear"
                    )}
                  </h4>
                  <Bar
                    data={{
                      labels: Object.keys(citesperyear),
                      datasets: [
                        {
                          label: "Cites",
                          backgroundColor: "rgba(0, 31, 84, 0.4)",
                          borderColor: "rgba(0, 31, 84,1)",
                          borderWidth: 1,
                          hoverBackgroundColor: "rgba(255,99,132,0.4)",
                          hoverBorderColor: "rgba(255,99,132,1)",
                          data: Object.values(citesperyear),
                        },
                      ],
                    }}
                    height={80}
                    options={{
                      plugins: {
                        datalabels: {
                          display: false,
                        },
                      },
                    }}
                  />
                </Col>
                <Col sm="12" md="4" style={{ color: "#001F54" }}>
                  <h4>
                    {t(
                      locale,
                      "/rs/profile/dashboardExternalScholar/interests"
                    )}
                  </h4>
                  <p>
                    {stringToArray(this.state.data.interests).map((e, i) => (
                      <li key={i}>{e}</li>
                    ))}
                  </p>
                </Col>
              </Row>
              <Row className="text-center">
                Google Scholar
                {t(locale, "/rs/profile/valid-for-all-publications")}
              </Row>
            </a>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default withRouter(DashboardExternalScholar);
